import Commands from './commands';

class Pop extends Commands {
    constructor(registry) {
        super("pop", registry);
    }

    async execute(node, emitter, options) {
        const key = await emitter(node.params[0], options);
        const value = this.registry.get(key) || [];
        if (!Array.isArray(value)) {
            throw "Invalid Assignment of array";
        }
        
        const popped = value.pop();
        this.registry.set(key, value);
        return popped;
    }
}

export default Pop;
